export const VALIDATE_MESSAGE = {
    REQUIRED: (label?: string) => `${label ? `${label} ` : ''}Trường thông tin này là bắt buộc`,
    MINLENGTH: (label: string, min: number) => `${label} tối thiểu ${min} ký tự`,
    MAXLENGTH: (label: string, max: number) => `${label} tối đa ${max} ký tự`,
    FORMATWRONG: (label: string) => `${label} không đúng định dạng`,
    DAYSLESSTHAN31:"Số ngày phải nhỏ hơn hoặc bằng 31",
    MONTHSLESSTHAN12:"Số tháng phải nhỏ hơn hoặc bằng 12",
    YEAR:"Số năm phải nằm trong khoảng 1900 - Năm hiện tại",
    INVALIDDOB:"Ngày sinh không hợp lệ",
    SPECIALDATE:"Ngày sinh không hợp lệ",
}
export const messageTypeFee = {
    P001:"thanh toán lần đầu",
    P002:"thanh toán định kỳ",
    P003:"Phí đóng thêm",
    P004:"phí khôi phục",
    P005:"phí bổ sung sản phẩm bổ trợ",
    P006:"phí thay đổi định kỳ đóng phí",
    
}

export const messageCodeErrorQueryContract = {
    ms001:"Truy vấn không thành công. Hotline: 024 2229 8888"
}
export const  messageQueryError = {
    msg007:"Không tìm thấy kết quả nào. Vui lòng liên hệ Hotline 024 2229 8888 để được hỗ trợ.",
    msg004:"Hồ sơ yêu cầu bảo hiểm này đã được phát hành. Vui lòng liên hệ hotline MB Life 024 2229 8888 để được hỗ trợ",
    msg001:"Không tìm thấy kết quả nào. Vui lòng liên hệ Hotline 024 2229 8888 để được hỗ trợ.",
    msg003:"Hợp đồng bảo hiểm không đủ điều kiện thanh toán",
    msg002:"Sản phẩm bảo hiểm này không được hỗ trợ thanh toán",
    msg012:"Không tìm thấy kết quả nào. Vui lòng liên hệ Hotline 024 2229 8888 để được hỗ trợ.",
    msg006:"Không tìm thấy kết quả nào. Vui lòng liên hệ Hotline 024 2229 8888 để được hỗ trợ.",
    msg008:"Hồ sơ yêu cầu bảo hiểm này đã được đóng phí. Vui lòng liên hệ hotline MB Life 024 2229 8888 để được hỗ trợ",
    msg500:"Đã có lỗi xảy ra",
    msg400:"Captcha is valid"
}
export const errorCode = {
    msg06:"007",
    msg07:"004",
    msg08:"001",
    msg09:"003 ",
    msg10:"",
    msg11:"002 ",
    msg12:"",
    msg13:"",
    msg14:"006",
    msg15:"008"
}

export const nameEformByTypeFee = {
    P003:"Bổ sung phí đóng thêm",
    P004:"Khôi phục hiệu lực hợp đồng",
    P005:"Bổ sung sản phẩm bổ trợ",
    P006:"Thay đổi định kỳ đóng phí",
    
}